var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#6C33B5",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 23.8333H31M25.1667 23.8333C25.6263 23.8333 26.0814 23.9239 26.5061 24.0998C26.9307 24.2756 27.3165 24.5335 27.6415 24.8585C27.9665 25.1835 28.2244 25.5693 28.4002 25.9939C28.5761 26.4186 28.6667 26.8737 28.6667 27.3333C28.6667 27.793 28.5761 28.2481 28.4002 28.6727C28.2244 29.0974 27.9665 29.4832 27.6415 29.8082C27.3165 30.1332 26.9307 30.391 26.5061 30.5669C26.0814 30.7428 25.6263 30.8333 25.1667 30.8333H24L27.5 34.3333M24 27.3333H31M38 28.5C38 29.8789 37.7284 31.2443 37.2007 32.5182C36.6731 33.7921 35.8996 34.9496 34.9246 35.9246C33.9496 36.8996 32.7921 37.6731 31.5182 38.2007C30.2443 38.7284 28.8789 39 27.5 39C26.1211 39 24.7557 38.7284 23.4818 38.2007C22.2079 37.6731 21.0504 36.8996 20.0754 35.9246C19.1004 34.9496 18.3269 33.7921 17.7993 32.5182C17.2716 31.2443 17 29.8789 17 28.5C17 25.7152 18.1062 23.0445 20.0754 21.0754C22.0445 19.1062 24.7152 18 27.5 18C30.2848 18 32.9555 19.1062 34.9246 21.0754C36.8938 23.0445 38 25.7152 38 28.5Z",
    stroke: "#7B3BCC",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeicon2);
export default __webpack_public_path__ + "static/media/homeicon_2.d611fb9b9b474ceae8aa6d5e4aeec034.svg";
export { ForwardRef as ReactComponent };